import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-survey",
  "use": "icon-survey-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-survey\"><defs><style type=\"text/css\"></style></defs><path d=\"M 992.075 472.143 s -198.869 127.155 -346.299 337.61 l -135.154 -119.708 l -58.8886 54.7513 l 232.934 260.655 s 107.02 -289.478 319.957 -496.347 l -12.5501 -36.9605 Z M 18.273 19.929 h 136.947 v 119.019 h -136.947 V 19.929 Z m 218.039 0.275825 h 548.064 v 118.467 H 236.313 V 20.204 Z m -218.039 353.056 h 136.947 v 119.019 h -136.947 v -119.019 Z m 218.039 0.137913 h 548.064 v 118.605 H 236.313 v -118.605 Z M 18.273 726.592 h 136.947 v 119.019 h -136.947 v -119.019 Z m 218.039 0.275825 h 157.634 v 118.605 H 236.313 v -118.605 Z m 0 0\" p-id=\"16109\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/survey.svg
// module id = Hiyp
// module chunks = 102